export default function (element, data) {
    window.addEventListener("open-popup-footnotes", function (e) {
        element.classList.add("open");
        document.body.classList.add('no-scroll');

        document.querySelector('.page-header').style.top = '-150px';
    });
    window.addEventListener("close-popup-footnotes", function () {
        element.classList.remove("open");
        document.body.classList.remove('no-scroll');
    });
    element.addEventListener("click", function (event) {
        window.dispatchEvent(new CustomEvent('close-popup-footnotes'));
    });
    element.querySelector(".footnotes__popup_block").addEventListener("click", function (event) {
        event.stopPropagation();
    });
}
